/* src/app/chat-widgets/chart-card/chart-card.component.css */
:host {
  display: block;
  height: 400px;
  width: 100%;
}
.chart-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.chart-card ::ng-deep .p-card-body,
.chart-card ::ng-deep .p-card-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  padding: 1rem;
}
/*# sourceMappingURL=chart-card.component-V2JEYK3Y.css.map */
